import { render, staticRenderFns } from "./WhatsappBasicPlanCard.vue?vue&type=template&id=03e174c7&scoped=true"
import script from "./WhatsappBasicPlanCard.vue?vue&type=script&lang=js"
export * from "./WhatsappBasicPlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e174c7",
  null
  
)

export default component.exports